export enum Shape {
  Squared = "square",
  Rounded = "round",
  Circled = "circle"
}
